export enum AssignmentType {
  TRAVEL = 1,
  STRIKE = 12,
}
